import { Api } from '@/infrastructure';
import { FavoriteRecreation } from '@/types';

type UseFacilityFavoriteRecreationsResult = {
  createFavoriteRecreation: (
    recreationId: number
  ) => Promise<FavoriteRecreation>;
  deleteFavoriteRecreation: (favoriteRecreationId: number) => Promise<void>;
};

export const useFacilityFavoriteRecreations =
  (): UseFacilityFavoriteRecreationsResult => {
    const createFavoriteRecreation = async (
      recreationId: number
    ): Promise<FavoriteRecreation> => {
      const data = {
        favorite_recreation: {
          recreation_id: recreationId,
        },
      };

      const response = await Api.post<FavoriteRecreation>(
        `favorite_recreations`,
        'customer',
        data
      );
      return response.data;
    };
    const deleteFavoriteRecreation = async (
      favoriteRecreationId: number
    ): Promise<void> => {
      await Api.delete(
        `favorite_recreations/${favoriteRecreationId}`,
        'customer'
      );
    };

    return {
      createFavoriteRecreation,
      deleteFavoriteRecreation,
    };
  };
